app.controller('BrowseCommonImageZoomController', ['$rootScope', '$scope', '$bootstrapModal', function ($rootScope, $scope, $bootstrapModal) {

    const isRange = !!$scope.is_range;
    const clickImgSrc = $scope.with_click_img_src;
    const zoomImgSrc = $scope.zoom_img_src;
    let currentZoomImgSrc = zoomImgSrc;
    $scope.click_img_src = null;
    $scope.img_name = "";

    $scope.applyValues = function (partialProduct) {
        const product = partialProduct;

        $scope.click_img_src = clickImgSrc ? clickImgSrc : (product && !product.disabled ? product.getImgSrc() : null);
        currentZoomImgSrc = zoomImgSrc ? zoomImgSrc : (product && !product.disabled ? product.getImgSrc() : null);
        $scope.img_name = product ? product.name : "";
        if (isRange) {
            const siteRangeName = $rootScope.navigation_model.state_values.site_range_name;
            if (siteRangeName) {
                $scope.img_name = siteRangeName + " " + $scope.img_name;
            }
        }
    }
    $scope.openImageZoom = function () {

        $bootstrapModal.open({
            templateUrl: 'BrowseCommonModalImageZoom.html',
            controller: 'CommonModalSimpleController',
            //size: 'md',
            resolve: {
                items: {
                    img_src: currentZoomImgSrc,
                    img_name: $scope.img_name
                }
            }
        });
    };

}]);
